import React, { SVGProps } from 'react';

const GreyRightArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="GreyRightArrow">
    <path
      d="m10.977 10.003-4.125 4.125 1.178 1.178 5.303-5.303L8.03 4.699 6.852 5.878l4.125 4.125Z"
      fill="var(--secondaryText)"
    />
  </svg>
);

export default GreyRightArrow;
